<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTasksStore } from 'dashboard/stores/tasks';

const props = defineProps({
  assignedToId: { type: Number, default: null },
  activeBucket: { type: String, default: null },
});

const emit = defineEmits(['select']);

const { t } = useI18n();
const tasksStore = useTasksStore();
const stats = ref({ dueToday: 0, overdue: 0, upcoming: 0 });

const cards = computed(() => [
  {
    key: 'dueToday',
    label: t('TASKS.LIST.STATS.DUE_TODAY'),
    value: stats.value.dueToday,
    cardClass: 'bg-n-teal-3 border-n-teal-5 hover:border-n-teal-7',
    textClass: 'text-n-teal-11',
  },
  {
    key: 'overdue',
    label: t('TASKS.LIST.STATS.OVERDUE'),
    value: stats.value.overdue,
    cardClass: 'bg-n-ruby-3 border-n-ruby-5 hover:border-n-ruby-7',
    textClass: 'text-n-ruby-11',
  },
  {
    key: 'upcoming',
    label: t('TASKS.LIST.STATS.UPCOMING'),
    value: stats.value.upcoming,
    cardClass: 'bg-n-slate-3 border-n-slate-5 hover:border-n-slate-7',
    textClass: 'text-n-slate-12',
  },
]);

const fetchStats = async () => {
  stats.value = await tasksStore.fetchStats(props.assignedToId);
};

onMounted(fetchStats);
watch(() => props.assignedToId, fetchStats);

defineExpose({ fetchStats });
</script>

<template>
  <div class="grid grid-cols-3 gap-3">
    <button
      v-for="card in cards"
      :key="card.key"
      type="button"
      class="flex flex-col gap-1 px-4 py-3 text-left rounded-xl border transition-colors"
      :class="[
        card.cardClass,
        activeBucket === card.key ? '!border-n-brand ring-1 ring-n-brand' : '',
      ]"
      @click="emit('select', card.key)"
    >
      <span class="text-2xl font-semibold" :class="card.textClass">
        {{ card.value }}
      </span>
      <span class="text-xs" :class="card.textClass">{{ card.label }}</span>
    </button>
  </div>
</template>
